let mixins = {}
try {
  // noinspection NpmUsedModulesInstalled
  mixins = require('marketing/giftcards/_mixins/giftcard-apply').default
} catch (e) {
  //
}

export default mixins
